module.exports = __webpack_public_path__ + "media/images/realizacje/real11-3ee256d6d6e034febff64027165304e5.png";